module.exports = __webpack_public_path__ + "static/media/image-gallery-5.3ceb0f91.jpg";